import React from 'react';
import { colorVariant } from './colorVariant';
import cn from '@/utils/cn';

interface SideNavSectionLabelProps {
  label: string;
}

const LABEL = cn(colorVariant({ text: 'navy-4' }), 'px-2 text-2xs font-medium');

const SideNavSectionLabel = ({ label }: SideNavSectionLabelProps) => (
  <div className={LABEL}>{label}</div>
);

export default SideNavSectionLabel;
